module.exports = __webpack_public_path__ + "static/media/rsz_massan-090.e80e170b.jpg";